module.exports = __webpack_public_path__ + "static/hackanile-dac3d7edbbca35c1208da0ea4ace7336.png";